<div id="main-wrapper" class="show">
  <app-header-secondary></app-header-secondary>

  <div class="content-body">
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer></app-footer>
</div>